const throttleLogs = (
	limit: number,
): {
	add: (fn: () => Promise<void>) => void;
	flush: () => Promise<void>;
} => {
	const queue: (() => Promise<void>)[] = [];
	let activeCount = 0;

	const next = () => {
		if (queue.length > 0 && activeCount < limit) {
			const fn = queue.shift();
			if (fn) {
				activeCount++;
				fn().finally(() => {
					activeCount--;
					next();
				});
			}
		}
	};

	const add = (fn: () => Promise<void>): void => {
		queue.push(fn);
		next();
	};

	const flush = async (): Promise<void> => {
		const promises = [];
		while (queue.length > 0) {
			const fn = queue.shift();
			if (fn) {
				promises.push(fn());
			}
		}
		await Promise.all(promises);
	};

	return { add, flush };
};

export default throttleLogs;
